export default "__VITE_ASSET__DYSqabOB__"